import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';
import moment from 'moment';
import * as actions from '../../../redux/actions/caseLookupSearchAction';
import { getSidebarData } from '../../../redux/actions/sidebarActions';
import * as errorActions from '../../../redux/actions/errorAction';
import Collapsible from '../../../components/common/Collapsible';
import Loading from '../../../components/common/Loading';
import { search as caseLookupSearch } from '../../../components/search/sections/util/caseLookup';
import { firstLetterCapitalize } from '../../../util/text';
import { initialFilters } from '../../../redux/reducers/caseLookupSearchReducer';
import courtsData from '../../../data/courts';
import searchImg from '../../../images/search-sm.png';
import './FacetsBlock.less';


const courtsMap = _.groupBy(courtsData, 'code');


class FacetsBlock extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedTab: 1,
    };
  }

  componentDidMount = () => {
    this.props.getSidebarData({ type: this.props.type });
  }

  changeTab = (tab) => {
    this.setState({ selectedTab: tab });
  }

  facetRowClick(facetRow) {
    const nameOfProperty = Object.keys(facetRow)[0];
    const valueOfProperty = facetRow[nameOfProperty];

    if (nameOfProperty === 'case_type') {
      if (valueOfProperty) {
        facetRow[nameOfProperty] = firstLetterCapitalize(valueOfProperty);
      } else {
        facetRow[nameOfProperty] = 'All';
      }
    }

    let searchFilter = facetRow;

    if (facetRow.year) {
      // this is not very terse but it's late for me :|
      facetRow.filed_from = moment(`${facetRow.year}/01/01`);
      facetRow.filed_to = moment(`${facetRow.year}/12/31`);

      searchFilter = {
        filed_from: `${facetRow.year}/01/01`,
        filed_to: `${facetRow.year}/12/31`,
        year: facetRow.year,
      };


      const datepickers = document.getElementsByClassName('react-datepicker__close-icon') || [];
      // can't use forEach on nodeitems in all browsers
      for (let i = 0; i < datepickers.length; i++) {
        datepickers[i].click();
      }

      // delete facetRow.year;
      // delete searchFilter.year;
    }

    if (facetRow.court_name) {
      const { court_name } = facetRow;
      facetRow = { region_name: court_name };
      searchFilter = { region_name: court_name };
    }

    this.props.actions.updateFilter(facetRow);
    caseLookupSearch.bind(this)(searchFilter, false);
  }

  clearAllFilter = () => {
    setTimeout(() => {
      if (this.props.filters.get('year')) {
        // this is a kind of a hack  bc of react-datepicker
        const datepickers = document.getElementsByClassName('react-datepicker__close-icon') || [];
        for (let i = 0; i < datepickers.length; i++) {
          datepickers[i].click();
        }
      }
      this.props.actions.clearAllFilter();
      caseLookupSearch.bind(this)({}, false);
    });
  };

  courtNameParse = (courtName, courtValue = '') => {
    const nameLengthLimit = courtValue ? 35 : 30;

    courtValue = typeof courtValue === 'number' ? courtValue.toString() : courtValue;

    const courtNameParsedChunkLast = courtValue.length ? ` (${courtValue})` : '';

    if (courtName.length + courtNameParsedChunkLast.length <= nameLengthLimit) {
      return courtName + courtNameParsedChunkLast;
    }

    const courtNameParsedChunkFirst = courtName.substr(0, nameLengthLimit - courtNameParsedChunkLast.length - 1);

    const suffix = (courtName !== 'Default')
      ? `…${courtNameParsedChunkLast}`
      : '';

    return `${courtNameParsedChunkFirst}${suffix}`;
  };

  render() {
    // const isFacetsDataAvailable = !this.props.facets.get('case_type').isEmpty();

    const { sidebarData } = this.props;

    let tabOneSections = [];
    let tabTwoSections = [];

    if (sidebarData.status === 'done') {
      if (sidebarData.tab_one) {
        tabOneSections = _.map(sidebarData.tab_one, (val, key) => {
          if (_.isEmpty(val.title)) {
            return (
              <div className="tab-section" key={key}>
                {val.links &&
                  val.links.map((p, i) => <div className="link" dangerouslySetInnerHTML={{ __html: p }} key={`searchlink${i}`} />)
                }
              </div>
            );
          }
          return (
            <div key={key}>
              <Collapsible
                initCollapsed={false}
                title={val.title}
              >
                <div className="tab-section">
                  {val.links &&
                  val.links.map((p, i) => <div className="link" dangerouslySetInnerHTML={{ __html: p }} key={`searchlink${i}`} />)
                  }
                </div>
              </Collapsible>
            </div>
          );
        });
      }

      if (sidebarData.tab_two) {
        tabTwoSections = _.map(sidebarData.tab_two, (val, key, idx) => {
          let contentOrLinks = null;

          if (val.view_content) {
            contentOrLinks = (<div className="link" dangerouslySetInnerHTML={{ __html: val.view_content }} key={`contentlink${idx}`} />);
          } else if (val.links) {
            contentOrLinks = val.links.map((p, i) => <div className="link" dangerouslySetInnerHTML={{ __html: p }} key={`searchlink${i}`} />);
          }

          if (_.includes(val.class || [], 'collapsible')) {
            return (
              <div key={key} className="tab-section tab-section-2">
                <Collapsible
                  initCollapsed={false}
                  title={val.title}>
                  {contentOrLinks}
                </Collapsible>
              </div>
            );
          }
          let title = null;
          if (val.title) {
            title = <div className="title" dangerouslySetInnerHTML={{ __html: val.title }} />
          }
          if (val.href) {
            title = <a className="title link" href={`/${val.href}`} dangerouslySetInnerHTML={{ __html: val.title }} />
          }

          return (
            <div className="tab-section tab-section-2" key={key}>
              {title}
              { contentOrLinks }
            </div>
          );
        });
      }
    }

    const facets = Object.keys(facetsData).map((facetName, index) => {
      const value = this.props.facets.get(facetName) ? this.props.facets.get(facetName).toJS() : {};

      const valueKeys = Object.keys(value);

      const facetRows = [];
      const courtValue = valueKeys[0];
      if (valueKeys.length === 1 && value[courtValue] === -1) {
        // in case if in facets block there was only 1 instance,
        // i.e. we've selected case type or one of the chapters, etc.
        const courtName =
          _.get(courtsMap, `['${courtValue}'][0]['name']`) ||
          firstLetterCapitalize(courtValue);
        const facetRowTitle = this.courtNameParse(courtName);

        facetRows.push(<div key={facetRows.length} className="link">
          <span
                          onClick={this.facetRowClick.bind(this, { [facetName]: null })}
                          className="ir-search-facet-link link-emulated active"
                        >(-)
          </span> {facetRowTitle}
        </div>);
      } else if (!_.isEmpty(value)) {
        const facetRowKeys = (facetName === 'court_name')
          ? valueKeys.sort()
          : valueKeys.sort().reverse();

        // in case if in facets block there was only various instances in current facet block
        // that we able to choose one for filter.
        facetRows.push(facetRowKeys.map((facetRowName, index) => {
          const courtName =
            _.get(courtsMap, `['${facetRowName}'][0]['name']`) ||
            firstLetterCapitalize(facetRowName);
          const courtValue = value[facetRowName];
          const facetRowTitle = this.courtNameParse(courtName, courtValue);

          return (
            <div key={index} className="link">
              <span
                              id={`left-panel-${facetRowName}`}
                              onClick={this.facetRowClick.bind(this, { [facetName]: facetRowName })}
                              className="ir-search-facet-link link-emulated active"
                            >{facetRowTitle}
              </span>
            </div>
          );
        }));
      }

      if (facetRows.length) {
        return (
          <div key={index} className="tab-section">
            <div className="title">
              <h4>{facetsData[facetName]}</h4>
            </div>
            {facetRows}
          </div>
        );
      }
    });

    const tabOneCls = (this.state.selectedTab === 1)
      ? 'ui-tabs-selected'
      : 'ui-state-default';

    const tabTwoCls = (this.state.selectedTab === 2)
      ? 'ui-tabs-selected'
      : 'ui-state-default';

    const facetComponents = _.compact(facets);
    const hasDataForRefineSearch = facetComponents.length > 1;

    const f = (hasDataForRefineSearch)
      ? (
        <Collapsible
          initCollapsed={false}
          title="Refine Search"
          key="refine-search">
          {facetComponents}
        </Collapsible>
      )
      : null;

    const t1 = tabOneSections.concat(f);

    const tabs = (
      <div className="tabs">
        <div className={`tab ${tabOneCls}`}>
          { t1 }
        </div>
        <div className={`tab ${tabTwoCls}`}>
          { tabTwoSections }
        </div>
      </div>
    );

    const loadingOrFacets = (this.props.sidebarData.status === 'loading')
      ? <Loading showOverride type="spinner" />
      : tabs;

    return (
      <div id="sidebar-first" className="facets-block">
        <ul className="ui-tabs-nav ui-helper-reset ui-helper-clearfix">
          <li className={`ui-state-default ${tabOneCls}`} onClick={this.changeTab.bind(null, 1)}>
            <a href="javascript:void(0)" className="icon">
              <img src={searchImg} alt="" />
            </a>
          </li>
          <li className={`ui-state-default ${tabTwoCls}`} onClick={this.changeTab.bind(null, 2)}>
            <a href="javascript:void(0)">Dashboard</a>
          </li>
        </ul>
        <div className="inside menu content inside-block ui-tabs-panel ui-widget-content ui-corner-bottom">

          { loadingOrFacets }
          {!_.isEqual(initialFilters, this.props.filters.toJS()) && hasDataForRefineSearch && (
            <div
              onClick={this.clearAllFilter}
              className="ir-search-facet-link ir-search-facet-clear link-emulated active clear-all"
            >Clear All Filters
            </div>
          )}
          <Loading type="spinner" />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const caseLookupSearchReducer = state.get('caseLookupSearchReducer');
  return {
    facets: caseLookupSearchReducer.get('facets'),
    filters: caseLookupSearchReducer.get('filters'),
    caseLookupSearchResults: state.get('caseLookupSearchResults'),
    sidebarData: state.get('sidebarData'),
  };
};

const mapDispatchToProps = dispatch => ({
  dispatch,
  actions: bindActionCreators(actions, dispatch),
  errorActions: bindActionCreators(errorActions, dispatch),
  getSidebarData: bindActionCreators(getSidebarData, dispatch),
});


const facetsData = {
  case_type: 'Type',
  chapter: 'Chapter',
  year: 'Year field',
  court_name: 'Court',
};

export default connect(mapStateToProps, mapDispatchToProps)(FacetsBlock);



/** WEBPACK FOOTER **
 ** ./src/pages/filings/FacetsBlock/FacetsBlock.js
 **/